<template>
  <div>
    <van-tabbar route active-color="#FF2F2F" inactive-color="#989898" z-index="997">
      <van-tabbar-item replace to="/mall/home">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? homeIcon.active : homeIcon.inactive" />
            <span class="f24 mtop8">首页</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/mall/classify">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? classifyIcon.active : classifyIcon.inactive" />
            <span class="f24 mtop8">分类</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/points-mall/home">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img :src="props.active ? integralIcon.active : integralIcon.inactive" />
            <span class="f24 mtop8">绿色积分</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/mall/order-list" :badge="paidNum">
        <template #icon="props">
          <div class="flexbox_column hcenter" style="position: relative">
            <img :src="props.active ? orderIcon.active : orderIcon.inactive" />
            <!-- <div class="num flexbox flex_center" v-if="paidNum">
                {{ paidNum }}
              </div> -->
            <span class="f24 mtop8">订单</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace to="/mall/mine">
        <template #icon="props">
          <div class="flexbox_column hcenter">
            <img :src="props.active ? mineIcon.active : mineIcon.inactive" />
            <span class="f24 mtop8">我的</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import {
  getStorage,
  setAppIdStorage,
  getAppIdStorage,
  getLocalStorageAndTime,
  setLocalStorageAndTime,
} from "@/libs/storage"
import { getcoordinateApi } from "@/utils/user"
import { getOrderPendingCountApi } from "@/utils/mall"
import { mapState } from "vuex"
const wx = require("weixin-js-sdk")
export default {
  name: "mall",
  data () {
    return {
      showShare: false,
      active: 0,
      value: "",
      homeIcon: {
        active: require("@/assets/images/mall/home-selected.png"),
        inactive: require("@/assets/images/mall/home.png"),
      },
      classifyIcon: {
        active: require("@/assets/images/mall/classify-selected.png"),
        inactive: require("@/assets/images/mall/classify.png"),
      },
      orderIcon: {
        active: require("@/assets/images/mall/my-order-selected.png"),
        inactive: require("@/assets/images/mall/my-order.png"),
      },
      integralIcon: {
        active: require("@/assets/images/mall/integral-selected.png"),
        inactive: require("@/assets/images/mall/integral.png"),
      },
      mineIcon: {
        active: require("@/assets/images/mall/mine-selected.png"),
        inactive: require("@/assets/images/mall/mine.png"),
      },
      selectCity: null,
      paidNum: "",
      infos_storage: null,
      appId: "",
      environment: "",
    }
  },
  computed: {
    ...mapState(["cachedViews"]),
  },
  created () {
    this.appId = getStorage("appId")
    this.environment = getStorage("environment")
    this.infos_storage = getAppIdStorage(this.appId) || {}
    this.appId = this.infos_storage.userInfo.appId
    this.getPayingNum()
  },
  mounted () {
    this.$store.commit("showBack", "true")
  },
  methods: {
    // 获取订单待付款数量
    async getPayingNum () {
      try {
        const RES = await getOrderPendingCountApi()
        const { data, code, msg } = RES.data
        if (code === 200) {
          this.paidNum = data ? data : ""
        } else {
          this.$toast(msg)
        }
      } catch (error) {
        console.log("获取订单待付款数量接口异常捕获", error)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .van-search {
  padding: 0 10px;
}

::v-deep .van-search__content {
  width: 100%;
  background: #ffffff;
  padding: 0;
}

.num {
  background: red;
  color: #fff;
  width: 13px;
  height: 13px;
  line-height: 13px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -7px;
  font-size: 12px;
}
</style>
